import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageService } from '../../services/language.service';
/**
 * Campaign Component
 */
let CampaignsComponent = class CampaignsComponent {
    constructor(httpClient, sanitizer, themeService, router, route, languageService) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.router = router;
        this.route = route;
        this.languageService = languageService;
        this.backColor = '';
        this.accentColor = '';
        this.mainColor = '';
        this.borderRadiusLarger = '';
        this.borderRadiusSmaller = '';
        this.textColor = '';
        this.errorColor = '';
        this.successColor = '';
        this.linkColor = '';
        this.inputBackColor = '';
        this.errorMessage = '';
        this.campaignHash = '';
        this.email = '';
        this.codeAssigned = false;
        this.submitClicked = false;
        this.assignedFee = 0;
        this.codeValidUntil = '';
        this.emailError = false;
        this.campaignExpired = false;
        this.themeService.getTheme().subscribe((data) => {
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
    }
    ngOnInit() {
        this.route.params.subscribe((params) => {
            this.campaignHash = params['hash'];
        });
        const data = { hash: this.campaignHash };
        this.httpClient.post('campaign/campaignexists', data).subscribe((data) => {
            if (!data) {
                this.campaignExpired = true;
            }
        });
    }
    assignDiscountCode() {
        this.submitClicked = true;
        const data = { hash: this.campaignHash, email: this.email };
        this.httpClient.post('campaign/assigndiscountcode', data).subscribe((data) => {
            this.codeAssigned = true;
            this.assignedFee = data['code_value'];
            this.codeValidUntil = data['valid_until'];
        });
    }
    checkEmail() {
        const reg = /^([A-Za-z0-9_\-\.\+])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,15})$/;
        if (reg.test(this.email) === false && this.email) {
            this.emailError = true;
            return false;
        }
        else {
            this.emailError = false;
            return true;
        }
    }
};
CampaignsComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: Router },
    { type: ActivatedRoute },
    { type: LanguageService }
];
CampaignsComponent = __decorate([
    Component({
        selector: 'ecd-campaigns',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./campaigns.component.html")).default
    })
], CampaignsComponent);
export { CampaignsComponent };
